// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.banner[data-v-533ed483] {\n  position: absolute;\n  left: 0;\n  width: 100%;\n  z-index: 100;\n}\n", ""]);
// Exports
module.exports = exports;
